import {Tooltip} from "primereact/tooltip";
import {useRef} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {RegisterSectionIIInput} from "../../app/object/TabRegister/SectionIIComponents";
import {navigateToRouteAndHash} from "../../hooks/navigationHooks";
import {selectVisibleObjectParametersCurried} from "../../redux/objectParametersSelectors";
import {selectSingleRegisterParam} from "../../redux/objectParametersSlice";

export default function ValuesIconSectionII({tooltipRef}) {
    const values = useSelector((state) => selectSingleRegisterParam(state, "register_abt2"));
    const registerSpec = useSelector(selectVisibleObjectParametersCurried("object/register", "all"));
    const ref = useRef(null);
    const navigate = useNavigate();

    if (!registerSpec?.length || registerSpec[0]?.blocks?.length < 3) {
        return null;
    }

    const tooltip = values && (
        <Tooltip target={`.${tooltipRef}`} className="spf-tooltip">
            <RegisterSectionIIInput columns={registerSpec?.[0]?.blocks?.[2]?.rows} compact={true} />
        </Tooltip>
    );

    return (
        <>
            {tooltip}
            <i
                ref={ref}
                className={`pi pi-info-circle tooltip-icon text-blue-500 ${tooltipRef}`}
                data-pr-position="top"
                onClick={() => navigateToRouteAndHash(navigate, "/object/register", "input_register_section_ii")}
            />
        </>
    );
}
